<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>门诊预约问诊管理</el-breadcrumb-item>
        <el-breadcrumb-item>用户预约信息管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="手机号：" prop="userMobile">
          <el-input maxlength="11" v-model="listParams.userMobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="问诊账号：" prop="medicalAccount">
          <el-input v-model="listParams.medicalAccount" placeholder="请输入问诊账号"></el-input>
        </el-form-item>
        <el-form-item label="预约时间：" prop="appointmentTime">
          <el-date-picker
            v-model="listParams.appointmentTime"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            type="datetimerange"
            value-format="timestamp"
            @change="handleDateChange"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="预约状态" prop="status">
          <el-select v-model="listParams.status" placeholder="请选择预约状态" clearable>
            <el-option label="已预约" :value="0"></el-option>
            <el-option label="已取消" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
          <el-button size="small" @click="resetForm('listForm')"> 重置 </el-button>
        </el-form-item>
      </el-form>

      <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <hx-table-result-col>
          <div class="wrap-table-info-display" style="height: 32px">
            <span class="table-info-display">
              <span>总条数：</span>
              <span class="alert-text ft16">{{ pager.total }}</span>
            </span>
          </div>
        </hx-table-result-col>

        <el-table slot="content" :data="tableData" max-height="600" border>
          <el-table-column fixed align="center" width="60" label="序号">
            <template slot-scope="scope">
              <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
            </template>
          </el-table-column>
          <el-table-column label="用户手机号" prop="userMobile" align="center"></el-table-column>
          <el-table-column label="问诊账号" prop="medicalAccount" align="center"></el-table-column>
          <el-table-column label="预约时间" prop="" align="center" width="200">
            <template slot-scope="scope">
              <p>{{ scope.row.ruleStartTime | formatDate(true) }}</p>
              <p>至</p>
              <p>{{ scope.row.ruleEndTime | formatDate(true) }}</p>
            </template>
          </el-table-column>
          <el-table-column label="预约医生" prop="doctorName" align="center"></el-table-column>
          <el-table-column label="预约状态" prop="status" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">已预约</span>
              <span v-if="scope.row.status === -1">已取消</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="openItem(scope.row)">查看</el-button>
              <confirm-button v-if="scope.row.status === 0" type="text" style="margin: 0 10px" title="确认要取消预约吗？" @confirmed="cancelItem(scope.row.id)">
                <span>取消预约</span>
              </confirm-button>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>
    <el-dialog title="预约详情" :visible.sync="dialogVisible">
      <el-form :model="dialogForm">
        <el-form-item label="预约ID：">{{ dialogForm.id }}</el-form-item>
        <el-form-item label="预约状态：">
          <span v-if="dialogForm.status === 0" style="color: green">已预约</span>
          <span v-if="dialogForm.status === -1" style="color: red">已取消</span>
        </el-form-item>
        <el-form-item label="预约时间：">{{ dialogForm.ruleStartTime | formatDate }} 至 {{ dialogForm.ruleEndTime | formatDate }}</el-form-item>
        <el-form-item label="预约时段：">{{ dialogForm.ruleStartTime | timeFrame }} 至 {{ dialogForm.ruleEndTime | timeFrame }}</el-form-item>
        <el-form-item label="科室："></el-form-item>
        <el-form-item label="专家：">{{ dialogForm.doctorName }}</el-form-item>
        <el-form-item label="就诊医院：">{{ dialogForm.hospitalName }}</el-form-item>
        <el-form-item label="" style="text-align: center">
          <el-button @click="dialogVisible = false" type="primary">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        userMobile: "",
        medicalAccount: "",
        userType: "1",
        appointmentTime: "",
        status: null,
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableLoading: false,
      tableData: [],
      dialogVisible: false,
      dialogForm: {},
    };
  },
  filters: {
    timeFrame(val) {
      let hours = new Date(val).getHours() + "";
      let minutes = new Date(val).getMinutes() + "";
      if (hours.length === 1) {
        hours = "0" + hours;
      }
      if (minutes.length === 1) {
        minutes = "0" + minutes;
      }
      return hours + ":" + minutes;
    },
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    loadTableData() {
      this.tableLoading = true;
      let listParams = JSON.parse(JSON.stringify(Object.assign(this.listParams, this.pager)));
      if (listParams.appointmentTime && listParams.appointmentTime.length > 0) {
        listParams.startTime = listParams.appointmentTime[0];
        listParams.endTime = listParams.appointmentTime[1];
        delete listParams.appointmentTime;
      }
      delete listParams.total;
      this.$http({
        url: global.apiUrl + "/medical/appointment/list",
        method: "GET",
        params: listParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableData = res.body.data.dataList;
            this.pager.total = res.body.data.total;
          }
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;
          console.error(err);
        });
    },
    resetForm(name) {
      this.$refs[name].resetFields();
      this.loadTableData();
    },
    handleDateChange(val) {
      this.loadTableData();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * @description: 查看详情
     * @param {*} row
     * @return {*}
     */
    openItem(row) {
      Object.assign(this.dialogForm, row);
      this.dialogVisible = true;
    },
    /**
     * @description: 取消预约
     * @param {*} id
     * @return {*}
     */
    cancelItem(appointmentId) {
      this.$http({
        url: global.apiUrl + `/medical/cancel/appointment?appointmentId=${appointmentId}`,
        method: "PUT",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="less" scoped></style>
